import { withInstall } from '@lit-element/utils'

import PageHeader from './src/page-header.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtPageHeader: SFCWithInstall<typeof PageHeader> =
  withInstall(PageHeader)
export default LtPageHeader

export * from './src/page-header'
